export interface RuntimeAuthConfig {
  authAuthority?: string;
  authClientId?: string;
}

let storedConfig: RuntimeAuthConfig = {};

export function setRuntimeConfig(config: RuntimeAuthConfig): void {
  storedConfig = config;
}

export function getRuntimeConfig(): RuntimeAuthConfig {
  return storedConfig;
}
